"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VALID_EMAIL_SERVICES = exports.SETTINGS_TABS = exports.PREVIEW_TYPES = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var PREVIEW_TYPES = (0, _keyMirror.default)({
  DESKTOP: null,
  MOBILE: null
});
exports.PREVIEW_TYPES = PREVIEW_TYPES;
var SETTINGS_TABS = (0, _keyMirror.default)({
  INFO: null,
  CALENDAR: null,
  DOMAIN: null
});
exports.SETTINGS_TABS = SETTINGS_TABS;
var VALID_EMAIL_SERVICES = ['GOOGLE_APPS', 'GOOGLE_FREE', 'OUTLOOK365'];
exports.VALID_EMAIL_SERVICES = VALID_EMAIL_SERVICES;